import React, { useEffect } from "react";
import { Provider } from "react-redux";
import localeData from "dayjs/plugin/localeData";
import dayjs from "dayjs";
import { message } from "antd";
import "./index.scss";

import { config } from "@triare/auth-redux";

import store from "./store";
import Routes from "./routes";
import AntdConfigProvider from "./AntdConfigProvider";
import { VaadTabsProvider } from "./components/Pages/Vaadim/SinglePage/VaadTabs/context";

const { displayName } = config;

dayjs.extend(localeData);

// Global toast duration (seconds) for all static message.* calls across pages.
message.config({ duration: 5 });

export default function App(): React.ReactNode {
  useEffect(() => {
    document.title = `${displayName}: Sign in`;
  }, []);

  return (
    <Provider store={store}>
      <AntdConfigProvider>
        <VaadTabsProvider>
          <Routes />
        </VaadTabsProvider>
      </AntdConfigProvider>
    </Provider>
  );
}
